/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Tag,
  Modal,
  Space,
  message,
  Typography,
  Row,
  Col,
  Descriptions,
  Image,
} from 'antd';
import { PlayCircleTwoTone } from '@ant-design/icons';
import { guuid } from '@/utils/utils';
import styles from './index.less';
import ModalVideo from '../ModalVideoKp';

const { Paragraph } = Typography;

const ClassActionView = (props) => {
  // eslint-disable-next-line react/prop-types
  const { detailRecord, infoList } = props;
  const [currentPlayURL, setCurrentPlayURL] = useState();
  const [videoVisible, setVideoVisible] = useState(false);
  const remakrStatusDict = {
    1: '待派单',
    2: '待点评',
    3: '已点评 ',
    4: '待审核',
    5: '已完成',
    6: '已取消',
    7: '无法点评',
    8: '作废',
  };
  const classRoomStatusDict = {
    1: '待上课',
    2: '上课中',
    3: '已下课',
    4: '已完课',
    5: '未上课',
    6: '旷课',
    7: '取消',
    8: '待领取',
    9: '到课热身',
    10: '到课训练',
  };

  const getRemarkResultView = (result) => {
    if (result === '完美完成') {
      return <Tag color="green">{result}</Tag>;
    } else if (result === '无法点评') {
      return <Tag color="red">{result}</Tag>;
    } else {
      return <span>{result}</span>;
    }
  };

  function onVideoPlay(url) {
    if (!url) {
      message.warn('暂无视频！');
      return;
    }
    setCurrentPlayURL(url);
    setVideoVisible(true);
  }

  function getUserAccount(wxNickName, phone) {
    if (wxNickName && phone) {
      console.log('1');
      return wxNickName + '(' + phone + ')';
    } else if (wxNickName) {
      console.log('2');
      return wxNickName;
    } else if (phone) {
      console.log('3');
      return phone;
    } else {
      console.log('4');
      return '-';
    }
  }

  const cancelXgModal = () => {
    setVideoVisible(false);
  };
  return (
    <div>
      <Paragraph>
        <blockquote>工单信息</blockquote>
      </Paragraph>
      <Descriptions column={{ sm: 2 }} size="small" bordered key="d1">
        <Descriptions.Item label="工单创建时间" key="1">
          {detailRecord?.ctime ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label="点评状态" key="2">
          {remakrStatusDict?.[detailRecord?.remarkStatus] ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label="课表ID及名称" key="3">
          {detailRecord?.roomId ? (
            <Tag color="purple">{detailRecord?.roomId}</Tag>
          ) : (
            ''
          )}
          {detailRecord?.title ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label="课表状态" key="4">
          {classRoomStatusDict?.[detailRecord?.classRoomStatus] ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label="用户账号" key="5">
          {getUserAccount(detailRecord?.wxNickName, detailRecord?.phone)}
        </Descriptions.Item>
        <Descriptions.Item label="完课时间" key="6">
          {detailRecord?.completeTime ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label="点评教练" key="7">
          {detailRecord?.remarkCoach ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label="调度ID及名称" key="8">
          {detailRecord?.scheduleId ? (
            <Tag color="purple">{detailRecord?.scheduleId}</Tag>
          ) : (
            ''
          )}
          {detailRecord?.scheduleName ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label="点评时间" key="9">
          {detailRecord?.commentTime ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label="无法点评" key="10">
          {detailRecord?.unRemark === undefined ||
          detailRecord?.unRemark === null
            ? '-'
            : detailRecord?.unRemark
            ? '是'
            : '否'}
        </Descriptions.Item>
      </Descriptions>

      <Paragraph>
        <blockquote>点评详情</blockquote>
      </Paragraph>

      {(infoList || []).map((e) => {
        return (
          <div className={styles.trrdd} key={guuid()}>
            <Row key={guuid()}>
              <Col
                span={24}
                style={{
                  display: 'flex',
                  background: 'lightgray',
                  height: '44px',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {e.stageName}
              </Col>
            </Row>
            {e.actionRemarkDetails?.map((item) => {
              return (
                <div key={guuid()}>
                  <Row className={styles.antRow}>
                    <Col className={styles.antCol} key={guuid()} span={5}>
                      {item.actionName}
                    </Col>
                    <Col className={styles.antCol} key={guuid()} span={3}>
                      {item.frequency}
                    </Col>
                    <Col className={styles.antCol} key={guuid()} span={5}>
                      {getRemarkResultView(item.remarkResult)}
                    </Col>
                    <Col className={styles.antCol} key={guuid()} span={8}>
                      <div
                        style={{
                          display: 'flex',
                          flexFlow: 'wrap',
                          paddingTop: 2,
                          paddingBottom: 2,
                        }}
                      >
                        {item.screenshots?.map((e) => (
                          <Image width={100} key={guuid()} src={e} />
                        ))}
                      </div>
                    </Col>
                    <Col className={styles.antCol} key={guuid()} span={3}>
                      <Space>
                        {item.videoUrl && (
                          <PlayCircleTwoTone
                            style={{ fontSize: 40 }}
                            onClick={() => onVideoPlay(item.videoUrl)}
                          />
                        )}
                      </Space>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        );
      })}
      <ModalVideo
        visible={videoVisible}
        src={currentPlayURL}
        onCancel={cancelXgModal}
      />
    </div>
  );
};

export default ClassActionView;
